import React from "react";
import Shop from "../component/shop/shop";
import AllShop from "../component/shop/allShop";
import Hero from "../component/hero/hero";
const Home = () => {
  return (
    <>
      <Hero />
      <Shop />

      {/* <AllShop /> */}
    </>
  );
};

export default Home;
